module.exports = __webpack_public_path__ + "static/media/Yaoli Mao.6c732d51.png";